var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-free:bin",
    clipPath: "url(#clip0_4464_112232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 16.25V48.75C7 50.5375 8.4625 52 10.25 52H39.5C41.2875 52 42.75 50.5375 42.75 48.75V16.25H7ZM16.75 45.5H13.5V22.75H16.75V45.5ZM23.25 45.5H20V22.75H23.25V45.5ZM29.75 45.5H26.5V22.75H29.75V45.5ZM36.25 45.5H33V22.75H36.25V45.5ZM43.5625 6.5H33V2.4375C32.9974 1.79183 32.7398 1.17333 32.2832 0.716764C31.8267 0.260199 31.2082 0.00256733 30.5625 0L19.1875 0C18.5418 0.00256733 17.9233 0.260199 17.4668 0.716764C17.0102 1.17333 16.7526 1.79183 16.75 2.4375V6.5H6.1875C5.54156 6.50172 4.92257 6.75907 4.46582 7.21582C4.00907 7.67257 3.75172 8.29156 3.75 8.9375V13H46V8.9375C45.9983 8.29156 45.7409 7.67257 45.2842 7.21582C44.8274 6.75907 44.2084 6.50172 43.5625 6.5ZM29.75 6.5H20V3.29225H29.75V6.5Z",
    fill: "#C6D3D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4464_112232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.2fac9a6d62d1e52464f8a8d0f9e32d92.svg";
export { ForwardRef as ReactComponent };